export const LOCAL_TREE_TYPE = {
  ESTABLISHMENT: -1,
  GROUP: 0,
  LOCAL: 1,
  DEVICE: 3,
};

export function normalizeSelection(nodes) {
  (nodes || []).forEach((node) => {
    node.selected = !!node.selected;
    normalizeSelection(node.children);
  });

  return nodes;
}

export function localTreeToFlat(nodes) {
  const flat = [];
  const seenKeys = new Set();

  const walk = (list, parentKey) => {
    (list || []).forEach((node) => {
      const id = node.type === LOCAL_TREE_TYPE.ESTABLISHMENT ? node.id : node.localTreeId;
      let key = id === undefined || id === null
        ? `${node.type}:${parentKey}:${node.name}`
        : `${node.type}:${id}`;

      if (seenKeys.has(key)) key = `${key}:${flat.length}`;
      seenKeys.add(key);

      flat.push({
        key,
        parentKey,
        label: node.name,
        searchText: [node.cidade, node.estado].filter(Boolean).join(" "),
        type: node.type,
        selected: !!node.selected,
        disabled: node.isAuthorized === false,
        isAtivo: node.isAtivo,
        isAuthorized: node.isAuthorized,
        cidade: node.cidade,
        estado: node.estado,
        raw: node,
      });

      walk(node.children, key);
    });
  };

  walk(nodes, null);

  return flat;
}
